const grids = {};

export default grids;
